(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["epac-motion"] && !Shopify.designMode) return;
  try {
    // The .epac-reveal hidden state in CSS is gated on this class existing on
  // <html> (see src/tailwind.css) — set it only here, immediately before the
  // observer attaches, so content can never be stuck invisible when this
  // script fails to run for any reason.
  document.documentElement.classList.add('epac-motion-ready');
  const epacRevealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('epac-in');
          epacRevealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );
  document.querySelectorAll('.epac-reveal').forEach((el) => epacRevealObserver.observe(el));

  const epacCountObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const target = Number(el.dataset.epacCount);
        let current = 0;
        const step = Math.max(1, Math.round(target / 40));
        const timer = setInterval(() => {
          current += step;
          if (current >= target) {
            current = target;
            clearInterval(timer);
          }
          el.textContent = current;
        }, 25);
        epacCountObserver.unobserve(el);
      });
    },
    { threshold: 0.5 }
  );
  document.querySelectorAll('[data-epac-count]').forEach((el) => epacCountObserver.observe(el));
  } catch(e) { console.error(e); }
})();

})();
